import { TextStyle } from "../../drawing";
import { AbstractRectangleValuedItem } from "./AbstractRectangleValuedItem";
import { ITextDrawable } from "./ITextDrawable";

export abstract class AbstractTextItem extends AbstractRectangleValuedItem implements ITextDrawable {
  constructor(typeKey: string, value: any) {
    super(typeKey, value);
  }

  public textStyle: TextStyle = new TextStyle();

  public dacsProcessType: string = null;
  public dacsItemName: string = null;
  public dacsItemCode: string = null;

  protected applyMembers(clone: AbstractTextItem): void {
    super.applyMembers(clone);
    clone.textStyle = this.cloneValue(this.textStyle);
    clone.dacsProcessType = this.cloneValue(this.dacsProcessType);
    clone.dacsItemName = this.cloneValue(this.dacsItemName);
    clone.dacsItemCode = this.cloneValue(this.dacsItemCode);
  }

  text(): string {
    // TODO: ここに入れると毎回変換が走るので基底クラスのvalue更新時にupdateできる仕組みを用意する？必要なら見直し.
    return this.valueToText(this.value);
  }

  protected abstract valueToText(value: any): string;
}
